import { Injectable } from '@angular/core';
import { ACCOUNT_TYPE, CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { Cargochief } from '@service/cargochief/cargochief.service';
import {
	DATE_MDY,
	DATE_MDY_LOCAL,
	INTEGRATION_TYPE,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	VETTING_SOURCE,
} from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class HaulpayService {
	constructor(private cargochief: Cargochief) {}

	logo() {
		return 'assets/icons/haulpay.png';
	}

	tooltip({ forBrokers, approvalDate }: { forBrokers?: boolean; approvalDate?: Date | string } = {}) {
		// When forBrokers is false, show the carrier-facing tooltip (about brokers being approved)
		if (forBrokers === false) {
			if (IS_NOT_NULL_OR_UNDEFINED(approvalDate)) {
				// Format the date and return tooltip with date
				const formattedDate = typeof approvalDate === 'string' ? approvalDate : DATE_MDY_LOCAL(approvalDate);
				return `Broker approved for factoring and credit on ${formattedDate}. <a href="https://freight.haulpay.io/cargochief_haulpay_lp" target="_blank" rel="noopener" class="text-underline">Get started today.</a>`;
			} else {
				// Return tooltip without date
				return `Broker approved for factoring and credit by HaulPay. <a href="https://freight.haulpay.io/cargochief_haulpay_lp" target="_blank" rel="noopener" class="text-underline">Get started today.</a>`;
			}
		}

		// Default tooltip for brokers viewing carriers (or when forBrokers is true or undefined)
		return `HaulPay Approved ${forBrokers ? 'brokers' : 'carriers'} have had their payment ID verified and cross checked with their authority for added trust.`;
	}
}
